import { Linea } from './linea';

export class SubLinea {
  linea: Linea;
  idLinea: string;
  idSubLinea: string;
  descSubLinea: string;
  seleccionado: boolean = false;
}
